import {Component} from "react";
import {Button, Modal} from "react-bootstrap";

interface NoPinState{
    show: boolean
}
export default class NoPin extends Component<{}, NoPinState> {
    state: NoPinState = {
        show: false,
    }

    render() {
        return <>
            <Button variant="link" onClick={() => {this.setState({show:true})}}>
                I didn't receive my PIN!
            </Button>

            <Modal show={this.state.show} onHide={() => {this.setState({show:false})}}>
                <Modal.Header closeButton>
                    <Modal.Title>Our Apologies!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        For security purposes, we need to deliver your PIN to the phone number created when you were
                        invited.
                    </p>
                    <p>
                        If you believe the phone number set for your invitation is incorrect, or you are unable to
                        receive a PIN at that number, please contact your administrator for assistance.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => {this.setState({show:false})}}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    }
}
